export const books = [

    {
    id: 1, 
    img: "https://m.media-amazon.com/images/I/51DNaiWfllL.jpg", 
    title: "The Beach House 👑",
    author: "📝 by Rachel Hanna "
    
}, 
    {
    id: 2, 
    img: "https://m.media-amazon.com/images/I/51BK2HZdAHL.jpg", 
    title: "The Restarting Point 📌",
    author: "📝 by Marci Bolden"
    
    },
    {
    id: 3, 
    img: "https://m.media-amazon.com/images/I/512oLKXu8DL.jpg", 
    title: "The Wedding At Seagrove 💖",
    author: "📝 by Rachel Hanna"
    
}
]